import { render, staticRenderFns } from "./indexSFZX.vue?vue&type=template&id=589f867a&"
import script from "./indexSFZX.vue?vue&type=script&lang=js&"
export * from "./indexSFZX.vue?vue&type=script&lang=js&"
import style0 from "./indexSFZX.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports